import { connect } from "react-redux";

import actions from "../../actions";
import ScheduleEditorBundleEneosKawasaki from "../../components/list/ScheduleEditorBundleEneosKawasaki";

const mapStateToProps = (state) => {
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateItemBundle: (data, handleSuccess, handleCancel) =>
      dispatch(actions.schedule_eneos_kawasaki.updateItemBundle(data, handleSuccess, handleCancel)),
    setUnloadAlert: () => dispatch(actions.app.setUnloadAlert()),
    clearUnloadAlert: () => dispatch(actions.app.clearUnloadAlert()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ScheduleEditorBundleEneosKawasaki);
